import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Pin, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

// Beranda banner for pinned admin announcements. Auto-rotating carousel when >1.
export function CommunityAnnouncement({ className }) {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    let cancelled = false;
    api
      .communityPinned()
      .then((r) => { if (!cancelled) setItems(r.pinned || []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 5000);
    return () => clearInterval(t);
  }, [items.length]);

  if (items.length === 0) return null;
  const item = items[Math.min(idx, items.length - 1)];

  return (
    <div className={className} data-testid="community-announcement">
      <button
        onClick={() => navigate("/app/komunitas")}
        className="flex w-full items-start gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-left transition-transform active:scale-[0.99]"
      >
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-emerald-600">
          <Pin className="h-4 w-4 text-white" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-bold uppercase tracking-wide text-emerald-700">
            Pengumuman {item.displayName}
            {items.length > 1 && <span className="ml-1 text-emerald-500">· {idx + 1}/{items.length}</span>}
          </p>
          <p className="mt-0.5 line-clamp-2 text-sm font-medium text-emerald-900">{item.text}</p>
        </div>
        <ArrowRight className="mt-1 h-4 w-4 shrink-0 text-emerald-500" />
      </button>
      {items.length > 1 && (
        <div className="mt-2 flex justify-center gap-1.5" data-testid="announcement-dots">
          {items.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              aria-label={`Pengumuman ${i + 1}`}
              className={`h-1.5 rounded-full transition-all ${i === idx ? "w-4 bg-emerald-600" : "w-1.5 bg-emerald-200"}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
